module.exports = __webpack_public_path__ + "static/media/raise.7cb2384f.png";